
export default {
  props: ["error"]
}
